import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20amber%20and%20soft%20cream%20tones%2C%20modern%20clean%20design%2C%20subtle%20security%20shield%20concept%2C%20minimalist%20background%20for%20educational%20website%2C%20no%20text%2C%20smooth%20gradients%2C%20professional%20atmosphere%2C%20high%20quality%20abstract%20wallpaper&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 mb-6">
          <i className="ri-shield-check-line text-accent-400 text-sm"></i>
          <span className="text-background-50/90 text-sm font-medium whitespace-nowrap">网络安全 · 公益教育平台</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          {siteInfo.fullName}
        </h1>
        <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-8">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/risk-warning"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-alert-line"></i>
            了解风险警示
          </Link>
          <Link
            to="/category/healthy-alternative"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer"
          >
            <i className="ri-heart-pulse-line"></i>
            发现健康替代
          </Link>
        </div>
      </div>
    </section>
  );
}